import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import vector from "../../../assets/svg/Vector.svg";
import MenuIcon from "../../../assets/svg/collapse-menu.svg";
import { PulseLoader } from "react-spinners";
import WarningIcon from "../../../assets/svg/warningIcon.svg";
import documentIcon from "../../../assets/svg/documentsIcon.svg";
import documentIconActive from "../../../assets/svg/documentsactiveIcon.svg";
import addIcon from "../../../assets/svg/plus.svg";
import addIconActive from "../../../assets/svg/plusActive.svg";
import favIcon from "../../../assets/svg/fav.svg";
import favIconActive from "../../../assets/svg/favActive.svg";
import pendingIcon from "../../../assets/svg/pending.svg";
import pendingIconActive from "../../../assets/svg/pendingActive.svg";
import FilterIcon from "../../../assets/svg/filterIcon.svg";
import FilterIconActive from "../../../assets/svg/filterIconactive.svg";
import $ from "jquery";
import requestIcon from "../../../assets/svg/request.svg";
import requestIconActive from "../../../assets/svg/requestActive.svg";
import completedtaskIcon from "../../../assets/svg/completedtaskIcon.svg";
import completedtaskActiveIcon from "../../../assets/svg/completedtaskactiveIcon.svg";
import settingsIcon from "../../../assets/svg/settings.svg";
import settingsIconActive from "../../../assets/svg/settingsActive.svg";
import LedgerIconActive from "../../../assets/svg/ledgeractive.svg";
import LedgerIcon from "../../../assets/svg/ledger.svg";
import uploadIcon from "../../../assets/svg/upload.svg";
import uploadIconActive from "../../../assets/svg/uploadActive.svg";
import ExpiryIconActive from "../../../assets/svg/activeExpiryPeriod.svg";
import ExpiryIcon from "../../../assets/svg/Expiryperiod.svg";
import MasterDataIcon from "../../../assets/svg/masterdataIcon.svg";
import MasterDataIconActive from "../../../assets/svg/masterdataactiveIcon.svg";
import SubCategoryIconActive from "../../../assets/svg/activesmallcategory.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import FujitecLogo from "../../../assets/svg/Fujitec.svg";
import notify from "../../../assets/svg/notify.svg";
import logoutimage from "../../../assets/svg/Logout.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import {
  rightBarClose,
  rightBarOpen,
  setPendingCountFn,
} from "../../../redux/action/Action";
import * as paths from "../../../helpers/routerPaths";
// import UserRole from "../../../helpers/role";
import axios from "axios";
import {
  NEW_DOCUMENT,
  UPLOAD_DOCUMENT,
  NOTIFICATIONS,
  SEARCH_BAR,
} from "../../../helpers/Rightbar_action";

import role from "../../../helpers/role";
import {
  GET_ALL_PENDINGTASKS,
  GET_NOTIFICATION_COUNT,
  GET_PENDINGTASKS_COUNT,
  PUT_INVALID_TOKEN,
} from "../../../helpers/endpointService";
import AppLauncher from "./AppLauncher";
import { logoutFunction } from "../../custom/commonFunction";
import NotificationBadge from "../../custom/NotificationBadge";
import { touchRippleClasses } from "@mui/material";
import { useCookies } from "react-cookie";

var removeClass = true;

var isMenu = false;

const TopBar = () => {
  // localStorage.setItem("Role", "Admin")
  const navigate = useNavigate();
  const path = window.location.pathname;
  let menuToggle = useSelector((state) => state.commonReducer.menuToggle);
  let Sidebar = useSelector((state) => state.commonReducer.Sidebar);
  let alertCancel = useSelector((state) => state.commonReducer.alertCancel);
  var NotificationCount = useSelector(
    (state) => state.commonReducer.NotificationCountNew
  );
  const {
    rightbarOpen,
    rightbarType,
    pendingCount,
    searchState,
    notifyCountState,
  } = useSelector((state) => ({
    rightbarOpen: state.documentReducer.rightbarOpen,
    rightbarType: state.documentReducer.rightbarType,
    pendingCount: state.documentReducer.pendingCount,
    searchState: state.documentReducer.searchState,
    notifyCountState: state.documentReducer.notifyCount,
  }));
  const dispatch = useDispatch();
  // const userMail = localStorage.getItem("userMail");
  const userId = localStorage.getItem("UserId");
  const [appMenu, setAppMenu] = useState(false);
  const [masterdataOptions, setMasterDataOptions] = useState(false);
  const [navigatePath, setnavigatePath] = useState("");
  const [sideMenu, setSideMenu] = useState(false);
  const [isTopbarLoader, setisTopbarLoader] = useState(false);
  const [isTopbarFailed, setisTopbarFailed] = useState(false);
  const [sideMenuMob, setSideMenuMob] = useState(false);
  const [userRole, setuserRole] = useState("");
  const [isMobile, setisMobile] = useState(false);
  const [isMobile1, setisMobile1] = useState(false);
  const [logout, setLogout] = useState(false);
  const [settingsOption, setSettingsOption] = useState(false);
  const [windowHeight, setwindowHeight] = useState(0);
  const [rightbarActive, setRightbarActive] = useState(false);
  const [iswarningdHide, setiswarningHide] = useState(false);
  const [notifyCount, setNotifyCount] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [imageTxt, setImageTxt] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies("");
  // const [userId, setuserId]=useState()

  const routeNavigation = (path) => {
    if (alertCancel === true) {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("LeaveNotificationPeriodScreen")
      );
      cancelPopup.show();
      setnavigatePath(path);
    } else {
      navigate(path);
      setSideMenuMob(!sideMenuMob);
    }
  };
  const sideMenuResize = () => {
    setSideMenu(!sideMenu);
    dispatch({ type: "MENU_TOGGLE", data: !sideMenu });
    // setIsMenuOpen(true)
    // resize()
  };

  const handleCancelPopup = () => {
    if (navigatePath === "search_bar") {
      dispatch({ type: "CANCEL", data: false });
      setiswarningHide(true);
      setnavigatePath("");
      openRightBar(SEARCH_BAR, false);
    } else if (navigatePath === "newDocument") {
      dispatch({ type: "CANCEL", data: false });
      setiswarningHide(true);
      setnavigatePath("");
      openRightBar(NEW_DOCUMENT, false);
    } else {
      dispatch({ type: "CANCEL", data: false });
      setiswarningHide(true);
      navigate(navigatePath);
      setnavigatePath("");
    }
  };

  useEffect(() => {
    setuserRole(localStorage.getItem("Role"));
    //setuserRole("admin");
    userProfile();
    /*   fetchNotifyCount(); */
    GetPendingTaskList();
    $(document).on("click", function (event) {
      var searchInput = $(".logout-style");
      if (removeClass && event.target != searchInput[0]) {
        setLogout(false);
      }
      removeClass = true;
    });
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  const userProfile = () => {
    // if(localStorage.getItem("userDataDecode")?.email){
    const userId = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
    //  const userId = "kevin.fleming@mail.com"
    if (userId) {
      const userRaw = userId.split(/[@]/);

      const user = userRaw[0].split(/[._-]/);

      if (user?.length === 1) {
        const user1 = user[0].charAt(0).toUpperCase() + user[0].slice(1);
        setFirstName(user1);
        setLastName(null);

        setImageTxt(user[0].charAt(0).toUpperCase());
      } else if (user?.length > 1) {
        const user1 = user[0].charAt(0).toUpperCase() + user[0].slice(1);
        const user2 = user[1].charAt(0).toUpperCase() + user[1].slice(1);
        setFirstName(user1);
        setLastName(user2);

        setImageTxt(user[0].charAt(0).toUpperCase());
      }
    }
  };

  useEffect(() => {
    // setIsMenuOpen(Sidebar);
    // resize();
  }, [isMenuOpen]);

  const resize = () => {
    setwindowHeight(window.innerHeight);
    if (window.innerWidth < 850) {
      if (!isMenu) {
        // dispatch({ type: "Sidebar", data: true });
        // setSideMenuMob(false);
        setSideMenuMob(false);
        isMenu = true;
        setIsMenuOpen(true);
      }

      setisMobile(true);
    } else {
      // dispatch({ type: "Sidebar", data: false });
      // setSideMenuMob(false);
      isMenu = false;
      setIsMenuOpen(false);
      setisMobile(false);
    }
    if (window.innerWidth < 360) {
      setisMobile1(true);
    } else {
      setisMobile1(false);
    }
  };

  const openRightBar = (type, value) => {
    if (alertCancel === true && value === true) {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("LeaveNotificationPeriodScreen")
      );
      cancelPopup.show();
      setnavigatePath(type);
    } else {
      if (type === NEW_DOCUMENT) {
        dispatch(rightBarOpen(NEW_DOCUMENT));
        routeNavigation(`/${paths.DOCUMENTS}`);
      } else if (type === UPLOAD_DOCUMENT) {
        dispatch(rightBarOpen(UPLOAD_DOCUMENT));
        routeNavigation(`/${paths.DOCUMENTS}`);
      } else if (type === SEARCH_BAR) {
        if (searchState === true && path !== `/${paths.SEARCH}`) {
          routeNavigation(`/${paths.SEARCH}`);
          dispatch(rightBarOpen(SEARCH_BAR)); //Ashwin
        }
        if (searchState === true && path === `/${paths.SEARCH}`) {
          dispatch(rightBarOpen(SEARCH_BAR));
        } else if (searchState === false) {
          dispatch(rightBarOpen(SEARCH_BAR));
          routeNavigation(`/${paths.SEARCH}`); //ashwin
        }
      } else if (type === NOTIFICATIONS) {
        dispatch(rightBarOpen(NOTIFICATIONS));
      }
    }
  };
  useEffect(() => {
    if (
      (rightbarOpen && rightbarType === NEW_DOCUMENT) ||
      (rightbarOpen && rightbarType === UPLOAD_DOCUMENT) ||
      (rightbarOpen && rightbarType === SEARCH_BAR)
    ) {
      setRightbarActive(true);
    } else {
      setRightbarActive(false);
    }
  }, [rightbarOpen, rightbarType]);

  const fetchNotifyCount = async () => {
    if (userId) {
      try {
        let notifyApiUrl = `${GET_NOTIFICATION_COUNT}?userId=${userId}`;
        const response = await axios.get(notifyApiUrl);

        if (response?.status === 200) {
          dispatch({ type: "NOTIFICATIONCOUNT", data: response.data });
          setNotifyCount(response.data);
        }
      } catch (err) {}
    }
  };

  useEffect(() => {
    fetchNotifyCount();
  }, [notifyCountState]);

  // // Set up interval to call the fetchNotifyCount function every minute (60000 milliseconds)
  // const interval = setInterval(fetchNotifyCount, 60000);

  // // Clear the interval after a specific time (e.g., 5 minutes)
  // setTimeout(() => {
  //   clearInterval(interval);
  // }, 5 * 60 * 1000); // 5 minutes in milliseconds

  const GetPendingTaskList = () => {
    let apiUrl = `${GET_PENDINGTASKS_COUNT}?userId=${userId}`;
    axios({
      method: "GET",
      url: apiUrl,
      data: {
        pageNumber: 1,
        pagesize: 50,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(setPendingCountFn(res.data));
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
  };

  const openLogoutModal = () => {
    removeClass = false;
    setLogout(!logout);
  };

  const LogoutYes = async () => {
    let AuthData = JSON.parse(localStorage.getItem("userDataDecode"));
    const cookieOptions = {
      domain: process.env.REACT_APP_COMMON_DOMAIN,
      path: "/",
    };
    removeCookie("refreshTokenDMS", cookieOptions);
    let apiUrl = `${PUT_INVALID_TOKEN}?email=${AuthData?.email}&applicationName=DMS`;
    setisTopbarLoader(true);
    axios({
      method: "PUT",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          // setisTopbarLoader(false);
          localStorage.clear();
          logoutDirect();
        }
      })
      .catch((err) => {
        setisTopbarLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  // const logoutDirect = () => {
  //   window.location.href = process.env.REACT_APP_LOGOUT;
  // };
  const logoutDirect = () => {
    // window.location.href = process.env.REACT_APP_LOGOUT;
    localStorage.clear();
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
    window.location.href = authUrl;
  };

  return (
    <>
      <div className={`row ${isMobile1 ? "mobile-app-head" : "px-2"} box `}>
        {isTopbarLoader && (
          <div className="spinner_overlay">
            <div className="loader">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}
        <div
          className={`${
            isMobile1 ? "col-8" : "col-6"
          } d-flex align-items-center`}
        >
          <img
            alt=""
            src={vector}
            className="cursor-pointer"
            onClick={() => setAppMenu(!appMenu)}
          />
          {isMobile == false && (
            <img alt="" src={FujitecLogo} className="pl-20 pt-2" />
          )}
          <label
            className={`${isMobile ? "pl-10" : "pl-30"} ${
              isMobile1 ? "mobilelabel-style" : "label-style"
            } `}
          >
            Document&nbsp;Management&nbsp;System
          </label>
        </div>
        <div
          className={`${
            isMobile1 ? "col-4 pr-0" : "col-6"
          } d-flex align-items-center justify-content-end`}
        >
          {/* <div>  */}
          <img
            alt=""
            src={notify}
            onClick={() => openRightBar(NOTIFICATIONS, true)}
            className="cursor-pointer width-20px"
          />

          <NotificationBadge
            /*  count={notifyCount} */
            count={NotificationCount}
          />
          {/* <div className="circle-small">{notifyCount}</div> */}
          {/* </div> */}

          <div
            className="d-flex cursor-pointer align-items-center"
            onClick={() => {
              removeClass = false;
              setLogout(!logout);
            }}
          >
            {isMobile == false && (
              <label className="cursor-pointer label-user pl-20">
                {JSON.parse(localStorage.getItem("userDataDecode"))?.name ||
                  `${firstName} ${lastName}`}
              </label>
            )}
            <div
              className="circle cursor-pointer"
              style={{ marginLeft: isMobile1 ? "5px" : isMobile ? "10px" : "" }}
            >
              {JSON.parse(localStorage.getItem("userDataDecode"))?.name?.charAt(
                0
              ) || imageTxt}
            </div>
          </div>
        </div>
      </div>
      {logout == true && (
        <div className="logout-style">
          <div
            className="pt-3 pl-10 pr-2 pb-2 logout-label text-overflow"
            title={JSON.parse(localStorage.getItem("userDataDecode"))?.email}
          >
            {JSON.parse(localStorage.getItem("userDataDecode"))?.email}
          </div>
          <div
            className="pt-2 pl-10 pr-2 pb-2 cursor-pointer logout-labelcursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#logoutPage"
            onClick={openLogoutModal}
          >
            <img src={logoutimage} />
            &nbsp;&nbsp;Log out
          </div>
        </div>
      )}
      {appMenu == true && (
        <AppLauncher isOpen={appMenu} setisOpen={setAppMenu} />
      )}
      {isMobile == false && (
        <>
          <div
            className={
              sideMenu == true
                ? "side-bar-menu side-scroll"
                : "side-bar side-scroll"
            }
            style={{ height: windowHeight - 1 }}
          >
            <img
              alt=""
              className="pl-20 pt-10 pb-10 cursor-pointer"
              src={MenuIcon}
              onClick={() => sideMenuResize()}
            />
            <br />

            {userRole === role.ADMIN ? (
              <>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.PENDING_TASKS}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.PENDING_TASKS}`)}
                >
                  <img
                    alt=""
                    className="blue"
                    src={
                      path == `/${paths.PENDING_TASKS}` && !rightbarActive
                        ? pendingIconActive
                        : pendingIcon
                    }
                  />
                  {sideMenu == false && (
                    <>
                      <div
                        className={`${
                          path == `/${paths.PENDING_TASKS}` && !rightbarActive
                            ? "fw-bold"
                            : ""
                        } pl-20 text-overflow app-label`}
                        style={{ left: "-3px", position: "relative" }}
                      >
                        My pending tasks
                        <span className="rejectedstatus-color ms-1">(</span>
                        <span
                          style={{
                            color: "#d12232",
                            fontWeight: "800",
                            fontSize: "12px",
                            marginTop: "1.2px",
                          }}
                        >
                          {pendingCount}
                        </span>
                        <span className="rejectedstatus-color ">)</span>
                      </div>
                    </>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.FAVORITES}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.FAVORITES}` && !rightbarActive
                        ? favIconActive
                        : favIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.FAVORITES}` &&
                        !rightbarOpen &&
                        rightbarType !== NEW_DOCUMENT
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      My favourites
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.DOCUMENTS}`)}
                >
                  <img
                    alt=""
                    src={
                      path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                        ? documentIconActive
                        : documentIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path.startsWith(`/${paths.DOCUMENTS}`) &&
                        !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Documents
                    </div>
                  )}
                </div>
                {/* Search */}
                <div
                  className={`pt-10 pb-10 ${
                    rightbarOpen && rightbarType === NEW_DOCUMENT
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => openRightBar(NEW_DOCUMENT, true)}
                >
                  <img
                    alt=""
                    src={
                      rightbarOpen && rightbarType === NEW_DOCUMENT
                        ? addIconActive
                        : addIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        rightbarOpen && rightbarType === NEW_DOCUMENT
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      New document
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    rightbarOpen && rightbarType === UPLOAD_DOCUMENT
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => openRightBar(UPLOAD_DOCUMENT, true)}
                >
                  <img
                    alt=""
                    style={{ height: "17px" }}
                    src={
                      rightbarOpen && rightbarType === UPLOAD_DOCUMENT
                        ? uploadIconActive
                        : uploadIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        rightbarOpen && rightbarType === UPLOAD_DOCUMENT
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Upload document
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => openRightBar(SEARCH_BAR, true)}
                >
                  <img
                    alt=""
                    src={
                      (path == `/${paths.SEARCH}` && !rightbarActive) ||
                      (rightbarOpen && rightbarType === SEARCH_BAR)
                        ? FilterIconActive
                        : FilterIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        (path == `/${paths.SEARCH}` && !rightbarActive) ||
                        (rightbarOpen && rightbarType === SEARCH_BAR)
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Search
                    </div>
                  )}
                </div>

                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.MY_REQUEST}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.MY_REQUEST}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.MY_REQUEST}` && !rightbarActive
                        ? requestIconActive
                        : requestIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.MY_REQUEST}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Document requests
                    </div>
                  )}
                </div>

                {sideMenu === false ? (
                  <div
                    className={` pt-10 pb-10 pl-20 ${
                      (path == `/${paths.CATEGORY1}` && !rightbarActive) ||
                      (path == `/${paths.CATEGORY2}` && !rightbarActive)
                        ? "sidebar-active pl-16"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                    onClick={() => {
                      setMasterDataOptions(!masterdataOptions);
                    }}
                  >
                    <img
                      alt=""
                      src={
                        (path == `/${paths.CATEGORY1}` && !rightbarActive) ||
                        (path == `/${paths.CATEGORY2}` && !rightbarActive)
                          ? MasterDataIconActive
                          : MasterDataIcon
                      }
                    />
                    {sideMenu == false && (
                      <div
                        className={`${
                          path == `/${paths.CATEGORY1}` ||
                          path == `/${paths.CATEGORY2}`
                            ? "fw-bold"
                            : ""
                        } pl-20 pr-20 text-overflow app-label`}
                      >
                        Master data
                      </div>
                    )}{" "}
                    {masterdataOptions === true && sideMenu === false ? (
                      <div className="col-3 d-flex justify-content-end">
                        <img alt="" src={UpArrowIcon} className="setting-img" />
                      </div>
                    ) : masterdataOptions === false && sideMenu === false ? (
                      <div className="col-3 d-flex justify-content-end">
                        <img
                          alt=""
                          src={DownArrowIcon}
                          className="setting-img"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <div
                    className={` pt-10 pb-10 pl-20 ${
                      (path == `/${paths.CATEGORY1}` && !rightbarActive) ||
                      (path == `/${paths.CATEGORY2}` && !rightbarActive)
                        ? "sidebar-active pl-16"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                    onClick={() => sideMenuResize()}
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.CATEGORY1}` || path == "/category2"
                          ? MasterDataIconActive
                          : MasterDataIcon
                      }
                    />
                  </div>
                )}

                {sideMenu === false && masterdataOptions === true ? (
                  <>
                    <div
                      className={`pt-10 pb-10 ${
                        path == `/${paths.CATEGORY1}` && !rightbarActive
                          ? ""
                          : ""
                      } d-flex pl-60 cursor-pointer`}
                      onClick={() => routeNavigation(`/${paths.CATEGORY1}`)}
                    >
                      <img
                        alt=""
                        src={
                          path == `/${paths.CATEGORY1}` && !rightbarActive
                            ? SubCategoryIconActive
                            : SubCategoryIcon
                        }
                      />
                      {sideMenu == false && (
                        <div
                          className={`${
                            path == `/${paths.CATEGORY1}` && !rightbarActive
                              ? "fw-bold"
                              : ""
                          } pl-10 pr-20 text-overflow app-label`}
                        >
                          Category 1
                        </div>
                      )}
                    </div>
                    <div
                      className={`pt-10 pb-10 ${
                        path == `/${paths.CATEGORY2}` && !rightbarActive
                          ? ""
                          : ""
                      } d-flex pl-60 cursor-pointer`}
                      onClick={() => routeNavigation(`/${paths.CATEGORY2}`)}
                    >
                      <img
                        alt=""
                        src={
                          path == `/${paths.CATEGORY2}` && !rightbarActive
                            ? SubCategoryIconActive
                            : SubCategoryIcon
                        }
                      />
                      {sideMenu == false && (
                        <div
                          className={`${
                            path == `/${paths.CATEGORY2}` && !rightbarActive
                              ? "fw-bold"
                              : ""
                          } pl-10 pr-20 text-overflow app-label`}
                        >
                          Category 2
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}

                {sideMenu === false ? (
                  <div
                    className={` pt-10 pb-10 pl-20 ${
                      (path == `/${paths.LEDGER}` && !rightbarActive) ||
                      (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                        ? "sidebar-active pl-16"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                    onClick={() => {
                      setSettingsOption(!settingsOption);
                    }}
                  >
                    <img
                      alt=""
                      src={
                        (path == `/${paths.LEDGER}` && !rightbarActive) ||
                        (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                          ? settingsIconActive
                          : settingsIcon
                      }
                    />
                    {sideMenu == false && (
                      <div
                        className={`${
                          (path == `/${paths.LEDGER}` && !rightbarActive) ||
                          (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                            ? "fw-bold"
                            : ""
                        } pl-20 pr-20 text-overflow app-label`}
                      >
                        Settings
                      </div>
                    )}{" "}
                    {settingsOption === true && sideMenu === false ? (
                      <div className="col-5 d-flex justify-content-end pr-10">
                        <img alt="" src={UpArrowIcon} className="setting-img" />
                      </div>
                    ) : settingsOption === false && sideMenu === false ? (
                      <div className="col-5 d-flex justify-content-end pr-10">
                        <img
                          alt=""
                          src={DownArrowIcon}
                          className="setting-img"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <div
                    className={` pt-10 pb-10 pl-20 ${
                      (path == `/${paths.LEDGER}` && !rightbarActive) ||
                      (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                        ? "sidebar-active pl-16"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                    onClick={() => sideMenuResize()}
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.LEDGER}` ||
                        path == `/${paths.EXPIRY_PERIOD}`
                          ? settingsIconActive
                          : settingsIcon
                      }
                    />
                  </div>
                )}

                {sideMenu === false && settingsOption === true ? (
                  <>
                    <div
                      className={`pt-10 pb-10 ${
                        path == `/${paths.LEDGER}` && !rightbarActive ? "" : ""
                      } d-flex pl-50 cursor-pointer`}
                      onClick={() => routeNavigation(`/${paths.LEDGER}`)}
                    >
                      <img
                        alt=""
                        src={
                          path == `/${paths.LEDGER}` && !rightbarActive
                            ? LedgerIconActive
                            : LedgerIcon
                        }
                      />
                      {sideMenu == false && (
                        <div
                          className={`${
                            path == `/${paths.LEDGER}` ? "fw-bold" : ""
                          } pl-10 pr-20 text-overflow app-label`}
                        >
                          Ledger
                        </div>
                      )}
                    </div>
                    <div
                      className={`pt-10 pb-10 ${
                        path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive
                          ? ""
                          : ""
                      } d-flex pl-50 cursor-pointer`}
                      onClick={() => routeNavigation(`/${paths.EXPIRY_PERIOD}`)}
                    >
                      <img
                        alt=""
                        src={
                          path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive
                            ? ExpiryIconActive
                            : ExpiryIcon
                        }
                      />
                      {sideMenu == false && (
                        <div
                          className={`${
                            path == `/${paths.EXPIRY_PERIOD}` ? "fw-bold" : ""
                          } pl-10 pr-20 text-overflow app-label`}
                        >
                          Notification period
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {/* <div
                  className={`pt-10 pb-10 ${path == `/${paths.AUDIT_LOG}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                    } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.AUDIT_LOG}`)}
                >
                  <img
                    alt=""
                    className="blue"
                    src={
                      path == `/${paths.AUDIT_LOG}` && !rightbarActive
                        ? AuditLogSelected
                        : AuditLogUnSelected
                    }
                  />
                  {sideMenu == false && (
                    <>
                      <div
                        className={`${path == `/${paths.AUDIT_LOG}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                          } pl-20 text-overflow app-label`}
                        style={{ left: "-3px", position: "relative" }}
                      >
                        Audit log
                      </div>
                    </>
                  )}
                </div> */}
              </>
            ) : userRole === role.REVIEWER ? (
              <>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.PENDING_TASKS}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.PENDING_TASKS}`)}
                >
                  <img
                    alt=""
                    className="blue"
                    src={
                      path == `/${paths.PENDING_TASKS}` && !rightbarActive
                        ? pendingIconActive
                        : pendingIcon
                    }
                  />
                  {sideMenu == false && (
                    <>
                      <div
                        className={`${
                          path == `/${paths.PENDING_TASKS}` && !rightbarActive
                            ? "fw-bold"
                            : ""
                        } pl-20 text-overflow app-label`}
                        style={{ left: "-3px", position: "relative" }}
                      >
                        My pending tasks
                        <span className="rejectedstatus-color ms-1">(</span>
                        <span
                          style={{
                            color: "#d12232",
                            fontWeight: "800",
                            fontSize: "12px",
                            marginTop: "1.2px",
                          }}
                        >
                          {pendingCount}
                        </span>
                        <span className="rejectedstatus-color ">)</span>
                      </div>
                    </>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.FAVORITES}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.FAVORITES}` && !rightbarActive
                        ? favIconActive
                        : favIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.FAVORITES}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      My favourites
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.DOCUMENTS}`)}
                >
                  <img
                    alt=""
                    src={
                      path.startsWith(`/${paths.DOCUMENTS}`)
                        ? documentIconActive
                        : documentIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path.startsWith(`/${paths.DOCUMENTS}`) &&
                        !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Documents
                    </div>
                  )}
                </div>
                {/* Search */}
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.SEARCH}` && !rightbarActive
                  } ? 'sidebar-active' : ''} d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => openRightBar(SEARCH_BAR, true)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.SEARCH}` ||
                      (rightbarOpen && rightbarType === SEARCH_BAR)
                        ? FilterIconActive
                        : FilterIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.SEARCH}` ||
                        (rightbarOpen && rightbarType === SEARCH_BAR)
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Search
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.MY_ACTIONS}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.MY_ACTIONS}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.MY_ACTIONS}` && !rightbarActive
                        ? completedtaskActiveIcon
                        : completedtaskIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.MY_ACTIONS}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      My completed tasks
                    </div>
                  )}
                </div>
              </>
            ) : userRole === role.USER ? (
              <>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.FAVORITES}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.FAVORITES}` && !rightbarActive
                        ? favIconActive
                        : favIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.FAVORITES}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      My favourites
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? "sidebar-active"
                      : ""
                  } d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.DOCUMENTS}`)}
                >
                  <img
                    alt=""
                    src={
                      path.startsWith(`/${paths.DOCUMENTS}`)
                        ? documentIconActive
                        : documentIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path.startsWith(`/${paths.DOCUMENTS}`) &&
                        !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Documents
                    </div>
                  )}
                </div>

                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.SEARCH}`
                  } ? 'sidebar-active' : ''} d-flex pl-20 cursor-pointer menuIcon`}
                  onClick={() => openRightBar(SEARCH_BAR, true)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.SEARCH}` ||
                      (rightbarOpen && rightbarType === SEARCH_BAR)
                        ? FilterIconActive
                        : FilterIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.SEARCH}` ||
                        (rightbarOpen && rightbarType === SEARCH_BAR)
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Search
                    </div>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
      {isMobile == true && (
        <div className="row mobile-sidebar position-fixed">
          <div className="col-12">
            <img
              alt=""
              className="pl-20 pb-10 cursor-pointer"
              style={{ paddingTop: "14px" }}
              src={MenuIcon}
              onClick={() => {
                setSideMenuMob(!sideMenuMob);
                // setIsMenuOpen(true);
                // resize();
              }}
            />
            <br />
          </div>
        </div>
      )}
      {isMobile == true && (
        <div
          className={`${
            sideMenuMob ? "sidebar-list" : "sidebar-list-close"
          } position-fixed side-scroll`}
          style={{ height: windowHeight - 1 }}
        >
          <img
            alt=""
            className="pl-20 pb-10 cursor-pointer"
            style={{ paddingTop: "14px" }}
            src={MenuIcon}
            onClick={() => setSideMenuMob(!sideMenuMob)}
          />
          <br />
          {userRole === role.ADMIN ? (
            <>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.PENDING_TASKS}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.PENDING_TASKS}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.PENDING_TASKS}` && !rightbarActive
                      ? pendingIconActive
                      : pendingIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.PENDING_TASKS}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 text-overflow app-label`}
                  style={{ left: "-3px", position: "relative" }}
                >
                  My pending documents{" "}
                  <span className="rejectedstatus-color ">(</span>
                  <span
                    style={{
                      color: "#d12232",
                      fontWeight: "800",
                      fontSize: "12px",
                      marginTop: "1.5px",
                    }}
                  >
                    {pendingCount}
                  </span>
                  <span className="rejectedstatus-color ">)</span>
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.FAVORITES}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.FAVORITES}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? favIconActive
                      : favIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  My favourites
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.DOCUMENTS}`)}
              >
                <img
                  alt=""
                  src={
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? documentIconActive
                      : documentIcon
                  }
                />
                <div
                  className={`${
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Documents
                </div>
              </div>
              {/* Search */}
              <div
                className={`${"pt-10 pb-10"} ${
                  rightbarOpen && rightbarType === NEW_DOCUMENT
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => openRightBar(NEW_DOCUMENT, true)}
              >
                <img
                  alt=""
                  src={
                    rightbarOpen && rightbarType === NEW_DOCUMENT
                      ? addIconActive
                      : addIcon
                  }
                />
                <div
                  className={`${
                    rightbarOpen && rightbarType === NEW_DOCUMENT
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  New document
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  rightbarOpen && rightbarType === UPLOAD_DOCUMENT
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => openRightBar(UPLOAD_DOCUMENT, true)}
              >
                <img
                  alt=""
                  style={{ height: "17px" }}
                  src={
                    rightbarOpen && rightbarType === UPLOAD_DOCUMENT
                      ? uploadIconActive
                      : uploadIcon
                  }
                />
                <div
                  className={`${
                    rightbarOpen && rightbarType === UPLOAD_DOCUMENT
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Upload document
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  (path == `/${paths.SEARCH}` && !rightbarActive) ||
                  (rightbarOpen && rightbarType === SEARCH_BAR)
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => openRightBar(SEARCH_BAR, true)}
              >
                <img
                  alt=""
                  src={
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? FilterIconActive
                      : FilterIcon
                  }
                />
                <div
                  className={`${
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Search
                </div>
              </div>

              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.MY_REQUEST}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.MY_REQUEST}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.MY_REQUEST}` && !rightbarActive
                      ? requestIconActive
                      : requestIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.MY_REQUEST}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Document requests
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  (path == `/${paths.CATEGORY1}` && !rightbarActive) ||
                  (path == `/${paths.CATEGORY2}` && !rightbarActive)
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => setMasterDataOptions(!masterdataOptions)}
              >
                <img
                  alt=""
                  src={
                    (path == `/${paths.CATEGORY1}` && !rightbarActive) ||
                    (path == `/${paths.CATEGORY2}` && !rightbarActive)
                      ? MasterDataIconActive
                      : MasterDataIcon
                  }
                />
                <div
                  className={`${
                    (path == `/${paths.CATEGORY1}` && !rightbarActive) ||
                    (path == `/${paths.CATEGORY2}` && !rightbarActive)
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Master data
                </div>
                {masterdataOptions === true ? (
                  <div className="col-3 d-flex justify-content-end">
                    <img alt="" src={UpArrowIcon} className="setting-img" />
                  </div>
                ) : masterdataOptions === false && sideMenu === false ? (
                  <div className="col-3 d-flex justify-content-end">
                    <img alt="" src={DownArrowIcon} className="setting-img" />
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {masterdataOptions === true ? (
                <>
                  <div
                    className={`${"pt-10 pb-10"} ${
                      path == `/${paths.CATEGORY1}` && !rightbarActive ? "" : ""
                    } d-flex pl-60 cursor-pointer`}
                    onClick={() => routeNavigation(`/${paths.CATEGORY1}`)}
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.CATEGORY1}` && !rightbarActive
                          ? SubCategoryIconActive
                          : SubCategoryIcon
                      }
                    />
                    <div
                      className={`${
                        path == `/${paths.CATEGORY1}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Category 1
                    </div>
                  </div>
                  <div
                    className={`${"pt-10 pb-10"} ${
                      path == `/${paths.CATEGORY2}` && !rightbarActive ? "" : ""
                    } d-flex pl-60 cursor-pointer`}
                    onClick={() => routeNavigation(`/${paths.CATEGORY2}`)}
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.CATEGORY2}` && !rightbarActive
                          ? SubCategoryIconActive
                          : SubCategoryIcon
                      }
                    />
                    <div
                      className={`${
                        path == `/${paths.CATEGORY2}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Category 2
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div
                className={`${"pt-10 pb-10"} ${
                  (path == `/${paths.LEDGER}` && !rightbarActive) ||
                  (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => setSettingsOption(!settingsOption)}
              >
                <img
                  alt=""
                  src={
                    (path == `/${paths.LEDGER}` && !rightbarActive) ||
                    (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                      ? settingsIconActive
                      : settingsIcon
                  }
                />
                <div
                  className={`${
                    (path == `/${paths.LEDGER}` && !rightbarActive) ||
                    (path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive)
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Settings
                </div>
                {settingsOption === true ? (
                  <div className="col-5 d-flex justify-content-end pr-10">
                    <img alt="" src={UpArrowIcon} className="setting-img" />
                  </div>
                ) : settingsOption === false && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end pr-10">
                    <img alt="" src={DownArrowIcon} className="setting-img" />
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {settingsOption === true ? (
                <>
                  <div
                    className={`${"pt-10 pb-10"} ${
                      path == `/${paths.LEDGER}` && !rightbarActive ? "" : ""
                    } d-flex pl-50 cursor-pointer`}
                    onClick={() => routeNavigation(`/${paths.LEDGER}`)}
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.LEDGER}` && !rightbarActive
                          ? LedgerIconActive
                          : LedgerIcon
                      }
                    />
                    <div
                      className={`${
                        path == `/${paths.LEDGER}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Ledger
                    </div>
                  </div>
                  <div
                    className={`${"pt-10 pb-10"} ${
                      path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive
                        ? ""
                        : ""
                    } d-flex pl-50 cursor-pointer`}
                    onClick={() => routeNavigation(`/${paths.EXPIRY_PERIOD}`)}
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive
                          ? ExpiryIconActive
                          : ExpiryIcon
                      }
                    />{" "}
                    <div
                      className={`${
                        path == `/${paths.EXPIRY_PERIOD}` && !rightbarActive
                          ? "fw-bold"
                          : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Notification period
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              {/* <div
                className={`${"pt-10 pb-10"} ${path == `/${paths.AUDIT_LOG}` && !rightbarActive
                  ? "sidebar-active"
                  : ""
                  } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.AUDIT_LOG}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.AUDIT_LOG}` && !rightbarActive
                      ? AuditLogSelected
                      : AuditLogUnSelected
                  }
                />
                <div
                  className={`${path == `/${paths.AUDIT_LOG}` && !rightbarActive
                    ? "fw-bold"
                    : ""
                    } pl-20 text-overflow app-label`}
                  style={{ left: "-3px", position: "relative" }}
                >
                  Audit log{" "}
                </div>
              </div> */}
            </>
          ) : userRole === role.REVIEWER ? (
            <>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.PENDING_TASKS}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.PENDING_TASKS}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.PENDING_TASKS}` && !rightbarActive
                      ? pendingIconActive
                      : pendingIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.PENDING_TASKS}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 text-overflow app-label`}
                  style={{ left: "-3px", position: "relative" }}
                >
                  My pending tasks{" "}
                  <span className="rejectedstatus-color ms-1">(</span>
                  <span
                    style={{
                      color: "#d12232",
                      fontWeight: "800",
                      fontSize: "12px",
                      marginTop: "1.2px",
                    }}
                  >
                    {pendingCount}
                  </span>
                  <span className="rejectedstatus-color ">)</span>
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.FAVORITES}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.FAVORITES}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? favIconActive
                      : favIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  My favourites
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.DOCUMENTS}`)}
              >
                <img
                  alt=""
                  src={
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? documentIconActive
                      : documentIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.DOCUMENTS}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Documents
                </div>
              </div>
              {/* Search */}
              <div
                className={`${"pt-10 pb-10"} ${
                  (path == `/${paths.SEARCH}` && !rightbarActive) ||
                  (rightbarOpen && rightbarType === SEARCH_BAR)
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => openRightBar(SEARCH_BAR, true)}
              >
                <img
                  alt=""
                  src={
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? FilterIconActive
                      : FilterIcon
                  }
                />
                <div
                  className={`${
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Search
                </div>
              </div>

              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.MY_ACTIONS}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.MY_ACTIONS}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.MY_ACTIONS}` && !rightbarActive
                      ? completedtaskActiveIcon
                      : completedtaskIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.MY_ACTIONS}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  My completed tasks
                </div>
              </div>
            </>
          ) : userRole === role.USER ? (
            <>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.FAVORITES}` && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.FAVORITES}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? favIconActive
                      : favIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.FAVORITES}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  My favourites
                </div>
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.DOCUMENTS}`)}
              >
                <img
                  alt=""
                  src={
                    path.startsWith(`/${paths.DOCUMENTS}`) && !rightbarActive
                      ? documentIconActive
                      : documentIcon
                  }
                />
                <div
                  className={`${
                    path == `/${paths.DOCUMENTS}` && !rightbarActive
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Documents
                </div>
              </div>

              <div
                className={`${"pt-10 pb-10"} ${
                  (path == `/${paths.SEARCH}` && !rightbarActive) ||
                  (rightbarOpen && rightbarType === SEARCH_BAR)
                    ? "sidebar-active"
                    : ""
                } d-flex pl-20 cursor-pointer`}
                onClick={() => openRightBar(SEARCH_BAR, true)}
              >
                <img
                  alt=""
                  src={
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? FilterIconActive
                      : FilterIcon
                  }
                />
                <div
                  className={`${
                    (path == `/${paths.SEARCH}` && !rightbarActive) ||
                    (rightbarOpen && rightbarType === SEARCH_BAR)
                      ? "fw-bold"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Search
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      )}
      <div
        className="modal fade modal-style"
        id="LeaveNotificationPeriodScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to proceed without saving changes?
              </h5>
              <span className="app-label">
                {" "}
                All the information you've entered will be lost.
              </span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${
                  isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                } `}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                className={`btn btn-light input-group d-flex ${
                  isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                }`}
                data-bs-dismiss="modal"
                onClick={() => handleCancelPopup()}
              >
                <span
                  style={{ fontSize: "14px" }}
                  className="model-label pl-10"
                >
                  Yes
                </span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <div
        id="logoutPage"
        className="modal fade modal-top"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4">
            <div className="row">
              <div className="col-12">
                <div className="px-1 py-3 align-middle border-bottom-modal">
                  <img src={logoutimage} style={{ marginTop: '-7px' }} />
                  <label className="modal-title text-20-bold pl-10">
                    Logout
                  </label>
                </div>
              </div>
            </div>
            <div>
              <div>
                <label className="text-16-bold pt-3">
                  Are you sure you want to log out?
                </label>
              </div>
            </div>
            <div className="py-3 text-center">
              <button
                className="cancel-button text-12-bold px-4 py-2"
                data-bs-dismiss="modal"
              >
                No
              </button>
              <button
                className="success-button text-12-bold px-4 py-2 ml-10"
                data-bs-dismiss="modal"
                onClick={LogoutYes}
              >
                Yes
              </button>
            </div>
          </div>
        </div> */}

      <div
        className="modal fade modal-style"
        id="logoutPage"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={logoutimage} />
                &nbsp;<span className="mt-1 pl-5"></span>Logout
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                Are you sure you want to log out?
              </h5>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${
                  isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                } `}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                onClick={LogoutYes}
                className={`btn btn-light input-group d-flex ${
                  isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                }`}
                data-bs-dismiss="modal"
              >
                <span
                  style={{ fontSize: "14px" }}
                  className="model-label pl-10"
                >
                  Yes
                </span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* </div> */}
    </>
  );
};

export default TopBar;
